import React from "react";
import payImg1 from "./images/paypal.webp";
import payImg2 from "./images/razorpay.webp";
import payImg3 from "./images/googlepay.webp";
import payImg4 from "./images/phonepay.webp";
import payImg5 from "./images/mastercard.webp";
import payImg6 from "./images/visa.webp";
import payImg7 from "./images/amexlogo.webp";

const logos = [payImg1, payImg2, payImg3, payImg4, payImg5, payImg7, payImg6];

const Payment_Method = () => {
    return (
        <section
            className="py-4 position-relative"
            style={{
                overflow: "hidden",
                background: "linear-gradient(180deg,#eef6ff 0%, #e7f0ff 40%, #ffffff 100%)",
                marginTop:40
            }}
        >
            <div
                className="px-5 x-xxl-5 px-6 mx-auto position-relative"
                style={{
                    maxWidth: "74%",
                    zIndex: 1,
                    marginTop: 10,
                }}
            >
                {/* Heading */}
                <div>
                    <h2 style={{ fontSize: "2.5rem", fontFamily: "Inter", fontWeight: 700, color: "#242121ff", lineHeight: 1.2 }}>
                        Payment Method
                    </h2>
                    <p
                        className="mt-2"
                        style={{ marginTop: -2, color: "#413e3eff", fontSize: "1.1rem", fontFamily: "Poppins", fontWeight: 300, lineHeight: 1.2 }}
                    >
                        Our payment partners are PayPal and Razorpay, so you can securely and confidently make payments from anywhere
                        in the world.
                    </p>
                </div>

                {/* Scrolling row */}
                <div className="pm-viewport">
                    <div className="pm-track" aria-hidden="true">
                        {[...logos, ...logos].map((src, i) => (
                            <div className="pm-card" key={`logo-${i}`}>
                                <img src={src} alt="payment logo" />
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <style>{`
        .pm-viewport{
          position: relative;
          margin-top: 28px;
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
          scrollbar-width: none;
          mask-image: linear-gradient(to right, transparent 0, black 48px, black calc(100% - 48px), transparent 100%);
          -webkit-mask-image: linear-gradient(to right, transparent 0, black 48px, black calc(100% - 48px), transparent 100%);
        }
        .pm-viewport::-webkit-scrollbar{ display: none; }

        .pm-track{
          display: flex;
          gap: 28px;                 /* a touch more spacing */
          padding: 8px 6px 12px;
          width: max-content;
          animation: pm-scroll 32s linear infinite;
        }

        /* BIGGER card size + stronger glass look */
        .pm-card {
  width: 280px;         
  height: 160px;        
  border-radius: 20px;
  padding: 20px;
  flex: 0 0 auto;
  display: flex;        
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, rgba(255,255,255,0.65), rgba(255,255,255,0.32));
  border: 1px solid rgba(17, 24, 39, .08);
  box-shadow: 0 6px 14px rgba(11, 27, 51, .10), inset 0 1px 0 rgba(255,255,255,.75);
  backdrop-filter: blur(6px);
  overflow: hidden;
}

/* Smaller image, always centered */
.pm-card img {
  max-width: 75%;       /* ⬅️ Shrink image size */
  max-height: 75%;      /* ⬅️ Shrink image size */
  object-fit: contain;
  display: block;
  margin: auto;       
  pointer-events: none;
}

        .pm-card:hover{
          transform: translateY(-2px);
          box-shadow:
            0 12px 24px rgba(11, 27, 51, .16),
            inset 0 1px 0 rgba(255,255,255,.85);
          transition: transform .25s ease, box-shadow .25s ease;
        }

        /* gentle infinite scroll; still draggable */
        @keyframes pm-scroll{
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .pm-viewport:hover .pm-track { animation-play-state: paused; }
      `}</style>
        </section>
    );
};

export default Payment_Method;
